/**
 * UX Sprint 2 — Row of readiness chips for a stage.
 *
 * Accepts a list of `{ label, status }` items and renders ReadinessPill
 * for each. Used by stage hero cards + composite workspaces.
 */
import ReadinessPill from "./ReadinessPill";

export default function ReadinessChips({ items = [], testidPrefix = "chip" }) {
    if (!items.length) return null;
    return (
        <div className="flex flex-wrap items-center gap-2" data-testid="readiness-chips">
            {items.map((item, i) => (
                <ReadinessPill
                    key={`${item.label}-${i}`}
                    status={item.status}
                    label={item.label}
                    testid={`${testidPrefix}-${(item.label || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                />
            ))}
        </div>
    );
}
